import { Container } from "@/types/v2";
import { normalizeLabels } from "@/lib/checkContainerConfiguration";

/**
 * Adds `labelToAdd` to a container's existing `linkedSourceLabel` value,
 * deduped, without dropping whatever labels were already there -- the bulk
 * canvas apply is additive, never a replace (see the plan's Global
 * Constraints).
 */
export function mergeLabelIntoContainer(
  existing: Container["linkedSourceLabel"],
  labelToAdd: string
): string[] {
  const current = normalizeLabels(existing);
  if (current.includes(labelToAdd)) return current;
  return [...current, labelToAdd];
}
